import Create from './create/CreateUser';
import List from './list/Users';

export default { List, Create };
